


const FooterSection = () => {
  return (
    <footer className="bg-book-darkBg text-book-darkBlue py-10 text-center text-sm">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <p className="mb-4">© {new Date().getFullYear()} Rey Marques | The Liberated Consultant</p>
          
          <div className="flex justify-center space-x-6 mb-4">
            <a href="/privacy.html" className="hover:text-book-orange transition-colors">Privacy Policy</a>
            <a href="/terms.html" className="hover:text-book-orange transition-colors">Terms of Service</a>
            <a href="/disclaimer.html" className="hover:text-book-orange transition-colors">Disclaimer</a>
            <a href="https://app.liberatedconsultant.com/" target="_blank" rel="noopener noreferrer" className="hover:text-book-orange transition-colors">Blog</a>
          </div>
          
          <p className="text-book-darkBlue/80 text-xs mb-2">
            Results are not guaranteed and depend on various factors including but not limited to your background, 
            experience, and work ethic. This book is for educational purposes only and is not 
            financial or business advice.
          </p>
          
          <p className="text-book-darkBlue/80 text-xs">
            Address: High Rise Talent Ventures LLC, 7250 S Durango Dr Ste 130-104, Las Vegas NV 89113 | Contact: <a href="https://www.linkedin.com/in/reymarques/" target="_blank" rel="noopener noreferrer" className="hover:text-book-orange">LinkedIn</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
